import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { NgRedux, NgReduxModule } from '@angular-redux/store';

import { ArgosState, rootReducer, INITIAL_STATE } from './core/argos-state';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { AutoEletricModule } from './auto-eletric/auto-eletric.module';
import { LoginModule } from './login/login.module';
import { ArgosPageRouter } from './argos-page-router';
import { DiagnosisModule } from './diagnosis/diagnosis.module';
import { CommandModule } from './command/command.module';
import { TokenInterceptor } from './core/token-interceptor';
import { Authenticator } from './core/authenticator';
import { RouterModule } from '@angular/router';
import { TechnicianModule } from './technician/technician.module';
import { CustomerModule } from './customer/customer.module';
import { BranchModule } from './branch/branch.module';
import { AppraisalModule } from './appraisal/appraisal.module';
import { AttendingModule } from './attending/attending.module';
import { AccessoryModule } from './accessory/accessory.module';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    NgReduxModule,
    CoreModule,
    RouterModule,
    DiagnosisModule,
    CommandModule,
    SharedModule,
    AutoEletricModule,
    LoginModule,
    ArgosPageRouter,
    TechnicianModule,
    CustomerModule,
    BranchModule,
    AppraisalModule,
    AttendingModule,
    AccessoryModule,
    NgReduxModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    TokenInterceptor,
    Authenticator,
    { provide: LocationStrategy, useClass: HashLocationStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(ngRedux: NgRedux<ArgosState>) {
    ngRedux.configureStore(rootReducer, INITIAL_STATE);
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/app.module.ts